import { Model } from '@vuex-orm/core'
import CallingPoint from './CallingPoint'
import Station from './Station'
import Journey from './Journey'

export default class JourneyLeg extends Model {
  static entity = 'legs'

  static fields() {
    return {
      id: this.increment(),
      position: this.attr(''),
      overall_position: this.attr(0),
      depart_assignee: this.attr(),
      arrival_assignee: this.attr(),
      rsid: this.attr(null),
      train_rid: this.attr(null),
      train_uid: this.attr(null),
      head_code: this.attr(null),
      calling_points: this.hasMany(CallingPoint, 'leg_id'),
      alight_station_id: this.attr(),
      board_station_id: this.attr(),
      destination_station_id: this.attr(),
      origin_station_id: this.attr(),
      journey_id: this.attr(null),
      journey: this.belongsTo(Journey, 'journey_id'),
      alight_station: this.attr(),
      board_station: this.attr(),
      destination_station: this.belongsTo(Station, 'destination_station_id'),
      origin_station: this.belongsTo(Station, 'origin_station_id'),
      destination_scheduled_arrival: this.attr(''),
      mode: this.attr('TRAIN'),
      origin_scheduled_departure: this.attr(''),
      realtime_arrival: this.attr(''),
      realtime_classification: this.attr('ONTIME'),
      realtime_departure: this.attr(''),
      scheduled_arrival: this.attr(''),
      scheduled_departure: this.attr(''),
      operator: this.attr({}),
      meeting_point: this.attr({ station_meeting_point_id: null, other_text: null }),
      departure_meeting_point: this.attr(''),
      arrival_meeting_point: this.attr(''),
      departure_assistances: this.attr([]),
      on_board_assistances: this.attr([]),
      arrival_assistances: this.attr([]),
      luggages: this.attr([]),
      duration: this.attr(''),
      reservations: this.attr([]),
      reservation_source: this.attr(null),
      service_identifier: this.attr(''),
      seats: this.attr([]),
      coach: this.attr(null),
      can_be_edited: this.attr(''),
      can_be_deleted: this.attr(''),
      additional_information: this.attr(''),
      incomplete_reasons: this.attr([]),
      origin_platform: this.attr(null),
      destination_platform: this.attr(null),
      status: this.attr(''),
      rars_leg_id: this.attr(''),
      rars_ref: this.attr(''),
      leg_stack_name: this.attr(null),
      leg_stack_id: this.attr(null),
      depart_assistance_details: this.attr(null),
      arrival_assistance_details: this.attr(null),
    }
  }

  $toJson() {
    const json = super.$toJson()

    if (this.overall_position === 0 || this.overall_position === null) json.overall_position = this.position

    return json
  }
}
